export default __webpack_public_path__ + "static/media/PEUGEOT_03.e9c5c7b5.gif";